// extracted by mini-css-extract-plugin
export var box = "_5p-1";
export var checkboxRow = "_5p-8";
export var checked = "_5p-2";
export var descriptionSpacer = "_5p-a";
export var disabled = "_5p-3";
export var icon = "_5p-6";
export var input = "_5p-0";
export var labelSpacer = "_5p-9";
export var medium = "_5p-5";
export var small = "_5p-4";
export var text = "_5p-7";